import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { PlatformEnums } from '@/utils/platforms';
import getCompanyPlatforms from 'API/Company/getCompanyPlatforms';
import pingco_logo_small from 'assets/images/pingco_logo_small.png';

const OperatorPlatformIcon = () => {
    const { currentCompanyPlatforms, currentCompany } = useSelector(
        (state) => state.navigationLists,
    );
    const { requiredScope } = useSelector((state) => state.login);

    const [platformData, setPlatformData] = useState(null);

    useEffect(() => {
        const fetchPlatform = async () => {
            // First check if platform exists in currentCompanyPlatforms
            let platform = currentCompanyPlatforms?.find(
                (p) => p.id === PlatformEnums.OPERATOR_PLATFORM,
            );

            // If not found, fetch from API as fallback
            if (!platform && currentCompany) {
                try {
                    const fallback = await getCompanyPlatforms(
                        requiredScope,
                        currentCompany,
                    );
                    platform = fallback?.find(
                        (p) => p.id === PlatformEnums.OPERATOR_PLATFORM,
                    );
                } catch (error) {
                    console.error('Error fetching company platforms:', error);
                }
            }
            setPlatformData(platform);
        };

        fetchPlatform();
    }, [currentCompanyPlatforms, currentCompany, requiredScope]);

    return (
        <div>
            <img
                src={
                    platformData?.logo
                        ? `${import.meta.env.VITE_APP_IMAGE_BASE}/images/uploads/${platformData.logo}`
                        : pingco_logo_small
                }
                alt="Operator Platform Logo"
                className="h-[25px] w-[25px] rounded-full"
            />
        </div>
    );
};

export default OperatorPlatformIcon;
